import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '*',
			redirect: '/'
		},
		{
			path: '/',
			name: 'home',
			component: (resolve) => require(['page/home/index'], resolve)
		},
		{
			path: '/find_orders',
			name: 'find_orders',
			component: (resolve) => require(['page/find_orders/index'], resolve)
		},
		{
			path: '/find',
			redirect: 'find_orders'
		},
		{
			path: '/stripe_cancel',
			name: 'cancel',
			component: (resolve) => require(['page/cancel/index'], resolve)
		},
		{
			path: '/cancel',
			redirect: 'stripe_cancel'
		},
		{
			path: '/stripe_success',
			name: 'success',
			component: (resolve) => require(['page/success/index'], resolve)
		},
		{
			path: '/success',
			redirect: 'stripe_success'
		}
	],
})